import type { DrivingLessonRecordType, TeachingLessonRecordType } from '@evidia/shared';
import type { Group } from './TeachingTab';
import { SectionHeaderStyled, StepperContainer, StepperMessage, StyledStepper } from './styles';

const getStepperMessage = (stepsDone: number, steps: number) => {
	switch (true) {
		case stepsDone === steps:
			return 'Dokončeno';
		case stepsDone === 0:
			return `Zbývá ${steps} lekcí`;
		case steps - stepsDone === 1:
			return 'Zbývá 1 lekce';
		default:
			return `Zbývá ${steps - stepsDone} lekce`;
	}
};

type Props = {
	section: Group;
};

const TitleMap: Partial<Record<TeachingLessonRecordType | DrivingLessonRecordType, string>> = {
	OP: 'OP',
	OUV: 'OUV',
	PV_UV: 'PV-UV',
	PV_ZP: 'PV-ZP',
	PPV: 'PPV',
	TZBJ: 'TZBJ',
	ZP: 'ZP',
};

export const SectionHeader = ({ section }: Props) => {
	const steps = section.items.length;
	const stepsDone = section.items.filter(item => !!item.date).length;

	return (
		<SectionHeaderStyled>
			<h3>{TitleMap[section.title]}</h3>
			<StepperContainer>
				<StyledStepper
					percent={(stepsDone / steps) * 100}
					steps={section.items.length}
					showInfo={false}
					strokeColor="#00B578"
				/>
				<StepperMessage>{getStepperMessage(stepsDone, steps)}</StepperMessage>
			</StepperContainer>
		</SectionHeaderStyled>
	);
};
